import { useState } from "react";
import { useData } from "../providers/ContextProvider";
import { FaRegUserCircle } from "react-icons/fa";
import "../styles/general.css";
import "../styles/queries.css";
import "../styles/SignUp.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function SignUp() {
  const [userSignupData, setUserSignupData] = useState({
    userName: "",
    emailID: "",
    password1: "",
    password2: "",
  });

  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { dispatch } = useData();

  const resetForm = () => {
    setUserSignupData({
      userName: "",
      password1: "",
      password2: "",
      emailID: "",
    });
  };

  const inputChangeHandler = (e) => {
    let newUserInput = {
      ...userSignupData,
      [e.target.name]: e.target.value,
    };
    setUserSignupData(newUserInput);
  };

  const submitHandler = async (e, dispatch) => {
    e.preventDefault();
    let newUser = {
      userName: userSignupData.userName,
      password: userSignupData.password1,
      emailID: userSignupData.emailID,
    };
    if (userSignupData.password1 === userSignupData.password2) {
      console.log({ userSignupData });
      const result = await axios
        .post("http://localhost:5000/signup", newUser)
        .catch((error) => {
          const errorMessage = error.response?.data?.errorMessage;
          setError(errorMessage);
          resetForm();
        });
      if (result.data?.success) {
        const userID = result.data.user;
        const token = result.data.token;
        dispatch({ type: "SIGNUP", payload: { userID, token } });
        navigate("/app/set-goals");
      }
    } else {
      setError("Passwords don't match.");
      resetForm();
    }
  };

  return (
    <main className="main">
      <div className="form-container signup-form-container">
        <h3 className="tertiary-heading form-heading">
          <FaRegUserCircle />
          Sign Up
        </h3>
        <div className="divider"></div>
        <form
          className="form signup-form"
          onSubmit={(e) => submitHandler(e, dispatch)}
        >
          <div>
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              name="userName"
              value={userSignupData.userName}
              placeholder="Akshita Saini"
              required
              onChange={(e) => inputChangeHandler(e)}
            ></input>
          </div>
          <div>
            <label htmlFor="emailID">Email ID</label>
            <input
              id="emailID"
              type="email"
              name="emailID"
              value={userSignupData.emailID}
              placeholder="user@gmail.com"
              required
              onChange={(e) => inputChangeHandler(e)}
            ></input>
          </div>
          <div>
            <label htmlFor="password">Create Password</label>
            <input
              id="password1"
              type="password"
              name="password1"
              value={userSignupData.password1}
              placeholder="********"
              required
              onChange={(e) => inputChangeHandler(e)}
            ></input>
          </div>
          <div>
            <label htmlFor="password">Enter Password Again</label>
            <input
              id="password2"
              type="password"
              name="password2"
              value={userSignupData.password2}
              placeholder="********"
              required
              onChange={(e) => inputChangeHandler(e)}
            ></input>
          </div>
          {error ? <div className="errorMessage">{error}</div> : ""}
          <button type="submit" className="btn btn-fill">
            Sign Up
          </button>
        </form>
      </div>
    </main>
  );
}

export default SignUp;
